import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import { HttpResponse } from "@angular/common/http";

import {NivelacionesService} from "../../nivelaciones/_services/nivelaciones.service";
import {Nivelacion} from "../../../_models/nivelacion";


@Injectable({
  providedIn: 'root'
})
export class NivelacionesAlumnoResolver  {

    constructor(private router: Router, private nivelacionesService: NivelacionesService) {
    }

    resolve(routeSnap: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Nivelacion[]> {
        let idMes = routeSnap.paramMap.get('idMes');
        return this.nivelacionesService.getNivelacionesAlumno(idMes)/*.map(nivelaciones => {
            return nivelaciones;
        })*/;
    }
}
